import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { getNumberValidFilter } from '@anytag/shared-utils';
import { BasicFilterDefaultProps } from '../../schemaTypes';
import { GenderField, KeywordField, InfluencerTabField, CountriesField } from '../../shared';
import { AllInfluencersFilterFormKeys, AllInfluencersFilterFormValues } from '../schemaTypes';
import { AdvancedFilter } from './AdvancedFilter';

export const BasicFilter = ({ onSubmit, isEngagementPage, isPackagePage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<AllInfluencersFilterFormValues>();

  const values = watch();
  const numOfValidFilter = getNumberValidFilter<AllInfluencersFilterFormKeys>(values, [
    'tab',
    'keyword',
    'genders',
    'includeIds',
    'countryIds'
  ]);

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
      <KeywordField onSubmit={onSubmit} placeholder={t<string>('Search.InfluencerFilter')} searchByCategories />
      <GenderField onSubmit={onSubmit} css={{ maxWidth: '123px' }} />
      <CountriesField onSubmit={onSubmit} />
      <AdvancedFilter count={numOfValidFilter} onSubmit={onSubmit} isEngagementPage={isEngagementPage} />
    </Form.Fields>
  );
};
